import { createContext, type ReactNode, useContext } from 'react';
import { create } from 'zustand/index';

import type { FrontTableProps, FrontTableStore } from '../helpers/types';

const useStore = create<FrontTableStore>((set) => ({
  searchQuery: '',
  setSearchQuery: (searchQuery) => set({ searchQuery }),
}));

const StoreContext = createContext<typeof useStore | null>(null);
export const TableContext = createContext<FrontTableProps<any>>({
  columns: [],
  data: [],
});

export const TableStoreProvider = ({ children }: { children: ReactNode }) => {
  return <StoreContext.Provider value={useStore}>{children}</StoreContext.Provider>;
};

export const useTableStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context();
};
